<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5 mb-0">{{planItemDetail.name}}</h1>
      <div class="columns">
        <div class="column is-7">
          <Correspondents :items="planItemDetail.executors"
                          :title="$t('docflow.executors')"
                          :editable="true"
                          :can-add-external="true"
                          type="planExecutors"
                          @add="addCorrespondent"
                          @remove="removeCorrespondent">
          </Correspondents>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import DashboardLayout from '@/components/DashboardLayout'
  import Attachments from '@/components/Attachments'
  import Correspondents from '@/components/Correspondents'
  import Comments from '@/components/Comments'
  import DocflowPlan from '@/components/DocflowPlan'
  import Timeline from '@/components/Timeline'
  import {timelineItem} from '@/constants'
  import {userDetail} from '@/utils'

  export default {
    components: {
      DashboardLayout,
      Correspondents,
      Attachments,
      DocflowPlan,
      Comments,
      Timeline
    },
    data() {
      return {
        stateColors,
        isNoteModalActive: false,
        noteModalMode: '',
        note: '',
        tabIndex: 0
      }
    },
    methods: {
      loadDetail() {
        this.$store.dispatch('Docflow/getItemDetail', {
          documentId: this.$route.params.documentId,
          itemId: this.$route.params.itemId
        })
      },
      addCorrespondent(correspondent) {
        if (correspondent.type !== 'new') {
          let data = {type: correspondent.type}
          data[correspondent.type] = correspondent.id
          this.$store.dispatch("Docflow/addItemCorrespondent", {
            documentId: this.$route.params.documentId,
            itemId: this.$route.params.itemId,
            correspondent: data
          }).then(() => this.loadDetail())
        } else {
          this.$store.dispatch("Docflow/addItemCorrespondent", {
            documentId: this.$route.params.documentId,
            itemId: this.$route.params.itemId,
            correspondent
          }).then(() => this.loadDetail())
        }
      },
      removeCorrespondent(correspondentId) {
        this.$store.dispatch("Docflow/removeItemCorrespondent", {
          documentId: this.$route.params.documentId,
          itemId: this.$route.params.itemId,
          correspondentId
        }).then(() => this.loadDetail())
      }
    },
    mounted() {
      this.loadDetail()
    },
    computed: {
      ...mapState('Docflow', ['planItemDetail']),
      breadcrumbs() {
        return [
          {name: 'docflow'},
          {name: 'docflowPlanItemDetail'}
        ]
      }
    },
    watch: {
      isNoteModalActive(state) {
        if (state)
          this.$nextTick(() => this.$refs.noteInput.focus())
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog {
    .input {
      resize: vertical;
      min-height: 80px;
    }
  }

  .edit {
    font-size: 13px !important;
    margin-left: 10px;

    .icon {
      margin-right: 2px;
    }
  }

  .document.description {
    color: #666;
    table {
      width: 100%;

      td {
        padding-bottom: 10px;
      }

      tr > td:first-child,
      tr > td:nth-child(3) {
        width: 140px;
      }
    }

    & > div {
      margin-top: 10px;
      & > p {
        margin-top: 4px;
      }
    }
  }
</style>
